import { useState, useEffect } from 'react';
import { useGLTF } from '@react-three/drei';
import { availableProducts } from '@config/products';

interface PreloadResult {
    isPreloading: boolean;
    progress: number;
    error: string | null;
}

export function useModelPreloader(): PreloadResult {
    const [isPreloading, setIsPreloading] = useState(true);
    const [progress, setProgress] = useState(0);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const preloadModels = async () => {
            try {
                const totalModels = availableProducts.length;
                let loadedCount = 0;

                // Preload all models
                const preloadPromises = availableProducts.map(async (product) => {
                    try {
                        await useGLTF.preload(product.glbUrl);
                        loadedCount++;
                        setProgress((loadedCount / totalModels) * 100);
                    } catch (err) {
                        console.error(`Failed to load ${product.name}:`, err);
                    }
                });

                await Promise.all(preloadPromises);

                // Small delay to ensure smooth transition
                await new Promise(resolve => setTimeout(resolve, 300));

                setIsPreloading(false);
            } catch (err) {
                console.error('Preloading error:', err);
                setError('Failed to load some models');
                setIsPreloading(false);
            }
        };

        preloadModels();
    }, []);

    return { isPreloading, progress, error };
}
